import { useQuery } from "@tanstack/react-query";
import { useContext, useRef } from "react";
import ComplianceConnectService from "@app/compliance-connect/common/complianceConnectService";
import { NetworkSubmissionFilterOptions } from "@app/compliance-connect/network-submission/interfaces";
import { UserContext } from "@app/user/UserContext";

interface UseNetworkSubmissionFilterOptionsResult {
  filterOptions: NetworkSubmissionFilterOptions | null;
  filterOptionsError: boolean;
  isLoading: boolean;
}

export function useNetworkSubmissionFilterOptions(): UseNetworkSubmissionFilterOptionsResult {
  const service = useRef(new ComplianceConnectService()).current;
  const user = useContext(UserContext);

  const { data, error, isPending } = useQuery({
    enabled: user?.userId != null && user?.clientId != null,
    queryFn: ({ signal }) => service.getFilterOptions(signal),
    queryKey: ["ns-filter-options", user?.userId, user?.clientId],
    staleTime: 5 * 60 * 1000,
  });

  return {
    filterOptions: data ?? null,
    filterOptionsError: error != null,
    isLoading: isPending,
  };
}
